import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';

const AdminPanelPage = () => {
  const location = useLocation();
  const isProducts = location.pathname.includes('/products');
  const isServices = location.pathname.includes('/services');
  const isSubscriptions = location.pathname.includes('/subscriptions');
  const isUsers = location.pathname.includes('/users');
  const isBanners = location.pathname.includes('/banners');
  const isCategories = location.pathname.includes('/categories');
  const isPlatforms = location.pathname.includes('/platforms');
  const isTopUpCards = location.pathname.includes('/top-up-cards');
  const navLinkClass =
    'flex min-w-[160px] items-center justify-center rounded-xl px-4 py-3 text-sm font-medium transition-colors';

  return (
    <div className="theme-light min-h-screen bg-gray-50 px-4 py-4 sm:px-6 sm:py-6 lg:px-8 lg:py-8">
      <div className="mx-auto max-w-7xl">
        <div className="overflow-hidden rounded-3xl border border-gray-200 bg-white shadow-sm">
          <div className="border-b border-gray-200 bg-gradient-to-r from-gray-50 to-white px-5 py-5 sm:px-6">
            <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
              <div className="flex items-center gap-3">
                <Link
                  to="/profile"
                  aria-label="Вернуться в профиль"
                  className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-700 transition hover:bg-gray-100"
                >
                  <span className="text-lg leading-none">←</span>
                </Link>
                <h1 className="mt-1 text-2xl font-bold text-gray-900">
                  Админская панель
                </h1>
              </div>
            </div>
          </div>

          <div className="flex flex-col lg:flex-row">
            <nav className="border-b border-gray-200 bg-gray-50/70 p-3 lg:w-72 lg:flex-shrink-0 lg:border-b-0 lg:border-r lg:p-5">
              <div className="flex gap-3 overflow-x-auto pb-1 lg:flex-col lg:overflow-visible">
                <Link
                  to="/admin/products"
                  className={`${navLinkClass} ${
                    isProducts
                      ? 'bg-gray-900 text-white shadow-sm'
                      : 'bg-white text-gray-700 ring-1 ring-inset ring-gray-200 hover:bg-gray-100'
                  }`}
                >
                  <span className="truncate">Товары</span>
                </Link>

                <Link
                  to="/admin/subscriptions"
                  className={`${navLinkClass} ${
                    isSubscriptions
                      ? 'bg-gray-900 text-white shadow-sm'
                      : 'bg-white text-gray-700 ring-1 ring-inset ring-gray-200 hover:bg-gray-100'
                  }`}
                >
                  <span className="truncate">Подписки</span>
                </Link>

                <Link
                  to="/admin/services"
                  className={`${navLinkClass} ${
                    isServices
                      ? 'bg-gray-900 text-white shadow-sm'
                      : 'bg-white text-gray-700 ring-1 ring-inset ring-gray-200 hover:bg-gray-100'
                  }`}
                >
                  <span className="truncate">Онлайн-сервисы</span>
                </Link>

                <Link
                  to="/admin/top-up-cards"
                  className={`${navLinkClass} ${isTopUpCards ? 'bg-gray-900 text-white shadow-sm' : 'bg-white text-gray-700 ring-1 ring-inset ring-gray-200 hover:bg-gray-100'}`}
                ><span className="truncate">Карты пополнения</span></Link>

                <Link
                  to="/admin/users"
                  className={`${navLinkClass} ${
                    isUsers
                      ? 'bg-gray-900 text-white shadow-sm'
                      : 'bg-white text-gray-700 ring-1 ring-inset ring-gray-200 hover:bg-gray-100'
                  }`}
                >
                  <span className="truncate">Пользователи</span>
                </Link>

                <Link
                  to="/admin/banners"
                  className={`${navLinkClass} ${
                    isBanners
                      ? 'bg-gray-900 text-white shadow-sm'
                      : 'bg-white text-gray-700 ring-1 ring-inset ring-gray-200 hover:bg-gray-100'
                  }`}
                >
                  <span className="truncate">Баннеры</span>
                </Link>

                <Link
                  to="/admin/categories"
                  className={`${navLinkClass} ${
                    isCategories
                      ? 'bg-gray-900 text-white shadow-sm'
                      : 'bg-white text-gray-700 ring-1 ring-inset ring-gray-200 hover:bg-gray-100'
                  }`}
                >
                  <span className="truncate">Категории</span>
                </Link>

                <Link
                  to="/admin/platforms"
                  className={`${navLinkClass} ${
                    isPlatforms
                      ? 'bg-gray-900 text-white shadow-sm'
                      : 'bg-white text-gray-700 ring-1 ring-inset ring-gray-200 hover:bg-gray-100'
                  }`}
                >
                  <span className="truncate">Платформы</span>
                </Link>
              </div>

              <div className="mt-4 hidden rounded-2xl border border-gray-200 bg-white p-4 text-sm text-gray-500 lg:block">
                В мобильной версии навигация превращается в горизонтальные вкладки, чтобы контенту оставалось больше места.
              </div>
            </nav>

            <main className="bg-white min-w-0 flex-1 p-4 sm:p-6">
              <Outlet />
            </main>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPanelPage;
